<template>
   <!-- 로그인된 채로 쓰는 사람용 «무료 이용권» — 안 쓴 이용권이 있고 AI 로켓등록 권한이 없을 때만 보인다.
        창은 로그인 화면(SignInModern.vue modal-coupon)과 같은 모양. «나중에»는 이 탭 동안만 창을 숨기고, 상단 버튼으로 다시 연다. -->
   <li v-if="available" class="nav-item header-ref-item">
      <button type="button" class="header-ref-link header-ref-link--btn is-alert"
         title="무료 이용권이 있습니다" @click="openModal">
         <span class="header-ref-icon"><i class="ri-coupon-3-line"></i></span>
         <span>무료 이용권</span>
      </button>
      <b-modal id="modal-coupon-offer" title="무료 이용권" hide-footer no-close-on-backdrop>
         <div class="alert alert-success d-block mb-3">
            <strong>{{ days }}일 무료 이용권이 있습니다.</strong>
            <div class="mt-1">사용하면 {{ days }}일 동안 <strong>AI 로켓등록</strong>이 열립니다. 지금 쓰시는 다른 기능은 그대로입니다.</div>
            <div class="mt-1">기간이 끝나면 이용권으로 열린 것만 닫힙니다.</div>
            <div class="mt-1 text-muted">나중에 쓰시려면 화면 위쪽 «무료 이용권» 버튼을 누르세요.</div>
         </div>
         <div v-if="error" class="alert alert-warning d-block mb-3">{{ error }}</div>
         <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-outline-secondary mr-2" :disabled="busy" @click="later">나중에</button>
            <button type="button" class="btn btn-success" :disabled="busy" @click="useCoupon">
               {{ busy ? '처리 중...' : '이용권 사용하기' }}
            </button>
         </div>
      </b-modal>
   </li>
</template>

<script>
import axios from 'axios'

const DISMISS_KEY = 'couponOfferDismissed'

export default {
   name: 'CouponOfferNav',
   data() {
      return { available: false, days: 0, busy: false, error: '' }
   },
   computed: {
      userId() {
         const u = this.$store.state.user
         return u && u._id
      },
      hasRocketReg() {
         const u = this.$store.state.user
         return !!(u && u.auth && u.auth.showRocketReg === true)
      }
   },
   watch: {
      // 계정 전환·로그인으로 사람이 바뀌면 다시 본다
      userId() { this.check() }
   },
   mounted() {
      this.check()
   },
   methods: {
      async check() {
         this.available = false
         // 이미 AI 로켓등록 메뉴가 있는 사람에게는 묻지도 않는다(서버도 같은 조건으로 거른다)
         if (!this.userId || this.hasRocketReg) return
         try {
            const res = await axios.get('/api/coupon/status')
            if (!res.data || !res.data.available || this.hasRocketReg) return
            this.days = res.data.days
            this.available = true
            let dismissed = false
            try { dismissed = sessionStorage.getItem(DISMISS_KEY) === String(this.userId) } catch (e) { console.error('[이용권] sessionStorage', e) }
            if (!dismissed) this.$nextTick(() => this.openModal())
         } catch (e) {
            console.error('[이용권] 상태 조회 실패', e)
         }
      },
      openModal() {
         this.error = ''
         this.$bvModal.show('modal-coupon-offer')
      },
      later() {
         try { sessionStorage.setItem(DISMISS_KEY, String(this.userId)) } catch (e) { console.error('[이용권] sessionStorage', e) }
         this.$bvModal.hide('modal-coupon-offer')
      },
      async useCoupon() {
         if (this.busy) return
         this.busy = true
         this.error = ''
         try {
            const res = await axios.post('/api/coupon/activate', {})
            if (res.data && res.data['요청결과'] === 'ok') {
               // 권한·메뉴는 로그인 정보에서 그려진다 — 새로 받아오도록 새로고침
               window.location.reload()
               return
            }
            this.error = (res.data && res.data.error) || '이용권을 사용하지 못했습니다.'
         } catch (e) {
            console.error('[이용권] 사용 실패', e)
            this.error = '이용권을 사용하지 못했습니다. 잠시 후 다시 시도해주세요.'
         } finally {
            this.busy = false
         }
      }
   }
}
</script>
